<template>
    <div class="position-relative">
        <loading :active.sync="isLoading"
                 :is-full-page="false"/>
        <form method="post" @submit.prevent="onSubmit">
            <input type="hidden" name="form_id" :value="formId">
            <div class="form-group">
                <input v-validate="'required'" :data-vv-as="'Name'" name="meta[full_name]" type="text" placeholder="Name" class="form-control" autocomplete="off" maxlength="255">
                <small class="error">{{ errors.first('meta[full_name]') }}</small>
            </div>
            <div class="form-group">
                <input v-validate="'required|email'" :data-vv-as="'Email address'" name="meta[email]" type="email" placeholder="Email address" class="form-control" autocomplete="off" maxlength="255">
                <small class="error">{{ errors.first('meta[email]') }}</small>
            </div>
            <div class="form-group">
                <input v-validate="'required'" :data-vv-as="'Subject'" name="meta[subject]" type="text" placeholder="Subject" class="form-control" autocomplete="off" maxlength="255">
                <small class="error">{{ errors.first('meta[subject]') }}</small>
            </div>
            <div class="form-group">
                <textarea v-validate="'required'" :data-vv-as="'Message'" name="meta[message]" placeholder="Message" class="form-control" autocomplete="off" maxlength="1000"></textarea>
                <small class="error">{{ errors.first('meta[message]') }}</small>
            </div>
            <div class="form-group text-center">
                <button type="submit" class="btn btn-default pl-5 pr-5">
                    <font-awesome-icon icon="envelope" class="mr-1" />
                    Submit
                </button>
            </div>
        </form>

        <div class="modal fade" id="message-sent" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body text-center">
                        <figure>
                            <img src="../assets/check.svg" height="50" alt="">
                        </figure>
                        <p>Your message has been sent</p>
                    </div>
                    <div class="modal-footer p-0">
                        <button type="button" class="btn" data-dismiss="modal">OK</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faHome, faEnvelope } from '@fortawesome/free-solid-svg-icons';

    library.add(faHome, faEnvelope);

    export default {
        name: 'ContactForm',

        data() {
            return {
                isLoading: false,
                formId: null,
            };
        },

        methods: {
            getForm() {
                fetch(
                    `${process.env.VUE_APP_BASE_URL}/api/forms/contact_us_ed`, {
                        headers: {
                            'X-Domain': process.env.VUE_APP_DOMAIN,
                        },
                    },
                )
                .then((response) => response.json())
                .then((form) => {
                    this.formId = form.data.id;
                });
            },

            onSubmit(e) {
                this.$validator.validateAll().then((a) => {
                    if (a) {
                        this.isLoading = true;
                        const data = new FormData(e.target);
                        fetch(
                            `${process.env.VUE_APP_BASE_URL}/api/forms`, {
                                method: 'POST',
                                body: data,
                                headers: {
                                    'X-Domain': process.env.VUE_APP_DOMAIN,
                                },
                            },
                        )
                        .then(() => {
                            e.target.reset();
                            $('#message-sent').modal('show');
                        })
                        .catch(() => {
                            // console.log(error);
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                    }
                });
            },
        },

        created() {
            this.getForm();
        },
    };
</script>

<style lang="scss">
    @import '../scss/variables';

    #message-sent {
        .modal-content {
            border: none;
            border-radius: 20px;
            box-shadow: 0 0 16px 6px rgba(0, 0, 0, .15);
        }
        .modal-body {
            color: $color_4;
            font-weight: 500;
            @include font-size(30px);
        }
        .modal-footer {
            button {
                @include font-size(30px);
                color: $color_3;
                font-weight: 500;
                margin: 0 auto;
            }
        }
    }
</style>
